var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2096 7.02216C24.7496 7.13788 25.0936 7.66947 24.9779 8.20949L21.9779 22.2095C21.8923 22.609 21.5722 22.9163 21.1695 22.9855C20.7668 23.0547 20.3625 22.872 20.1484 22.5241L17.246 17.8077L14.943 24.3328C14.8203 24.6806 14.5161 24.9325 14.1516 24.9884C13.787 25.0443 13.4213 24.895 13.2001 24.6L11.0001 21.6666L8.80006 24.6C8.46869 25.0418 7.84189 25.1313 7.40006 24.8C6.95823 24.4686 6.86869 23.8418 7.20006 23.4L10.2001 19.4C10.3889 19.1482 10.6853 19 11.0001 19C11.3148 19 11.6112 19.1482 11.8001 19.4L13.6789 21.9051L16.0571 15.1671C16.1853 14.8038 16.5109 14.5464 16.8941 14.5056C17.2772 14.4648 17.6498 14.6477 17.8517 14.9759L20.5448 19.3521L23.0223 7.79043C23.138 7.25041 23.6696 6.90644 24.2096 7.02216Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic);
export default __webpack_public_path__ + "static/media/graphic.d4f980b144352fb11d494ac6ff070a21.svg";
export { ForwardRef as ReactComponent };